import React from 'react'
import { ScrollView, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { RouteProp, useNavigation, useRoute } from '@react-navigation/core'
import { StyleService, useStyleSheet } from '@src/style/service'
import { glucoseEducationImage } from '@assets/images'
import { Text, Button } from '@components/base'
import { AppRouteProp, DrawerParamList } from '@navigation/types'
import { NavigationContainer } from '@screens/Common/containers'
import { EducationSection } from '@screens/Education'
import { useLazyScreenPreload } from '@src/navigation/utils'

export const Education = () => {
  const styles = useStyleSheet(themedStyle)
  const insets = useSafeAreaInsets()
  const navigation = useNavigation()
  const route = useRoute<AppRouteProp<'EducationModal'> | RouteProp<DrawerParamList, 'Education'>>()

  const isModal = route.name === 'EducationModal'

  const skipTutorial = () => {
    navigation.navigate('SkipTutorial')
  }

  useLazyScreenPreload('SupportHub')

  const goToSupportHub = () => {
    navigation.navigate('SupportHub')
  }

  const FAQLink = (
    <EducationSection
      key="FAQ"
      title="FAQ"
      accessibilityLabel="FAQ"
      imageSource={glucoseEducationImage.imageSource}
      onPress={goToSupportHub}
    />
  )

  const educationLinks = [FAQLink]

  return (
    <NavigationContainer
      title="Education"
      isDrawerScreen
      leftIcon={isModal ? { pack: 'eva', name: 'close' } : undefined}
      goBack={isModal ? skipTutorial : undefined}
      style={{ flex: 1 }}
    >
      <ScrollView
        style={styles.container}
        contentContainerStyle={{ flex: 1, paddingBottom: insets.bottom + 16 }}
      >
        <Text type="title-2">Here’s something to learn</Text>
        <Text type="regular" style={styles.subtitle}>
          If you don’t know what to do with the app or the Biosensor, you can learn it here!
        </Text>
        <View style={styles.sections}>{educationLinks}</View>
        {isModal && (
          <Button type="transparent" size="block" accessibilityLabel="Skip" onPress={skipTutorial}>
            Skip
          </Button>
        )}
      </ScrollView>
    </NavigationContainer>
  )
}

const themedStyle = StyleService.create({
  container: {
    flex: 1,
    paddingTop: 16,
    paddingHorizontal: 16,
    backgroundColor: 'theme.background',
  },
  subtitle: {
    marginTop: 16,
  },
  sections: {
    flex: 1,
    marginVertical: 24,
  },
})
